// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"e6b57064","425":"b832b857","510":"d6d6a962","532":"414d80e7","633":"330e5f5c","634":"815a865e","922":"98383a8b","937":"82f39d21","972":"e239f222"}[chunkId] + ".chunk.js";
};